import { render, staticRenderFns } from "./v-radio.vue?vue&type=template&id=a04c8c44&scoped=true&"
import script from "./v-radio.vue?vue&type=script&lang=js&"
export * from "./v-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04c8c44",
  null
  
)

export default component.exports